import PropTypes from "prop-types";
import slugify from "slugify";
import Link from "next/link";

import { CategoriesMobile, Title, Items, Item } from "./Mobile.styled";

export default function Mobile({ currentItem, categoriesList }) {
    return (
        <CategoriesMobile>
            <Title>Ik heb een vraag over…</Title>

            <Items horizontal>
                {categoriesList.map(category => {
                    return (
                        (category?.articles?.length > 0 ||
                            category?.mostpopular?.length > 0) && (
                            <Item
                                key={category.name}
                                active={category.name === currentItem}
                            >
                                <Link
                                    href="/helpdesk/[category]"
                                    as={`/helpdesk/${slugify(category.name, {
                                        lower: true
                                    })}`}
                                    passHref
                                >
                                    <a>{category.name}</a>
                                </Link>
                            </Item>
                        )
                    );
                })}
            </Items>
        </CategoriesMobile>
    );
}

Mobile.defaultProps = {
    currentItem: undefined
};

Mobile.propTypes = {
    currentItem: PropTypes.string,
    categoriesList: PropTypes.arrayOf(PropTypes.object).isRequired
};
